export default {
  // System Common
  'sys.serialNumber': 'STT',
  'sys.status': 'Trạng thái',
  'sys.operation': 'Thao tác',
  'sys.cancel': 'Hủy',
  'sys.confirm': 'Xác nhận',
  'sys.add': 'Thêm mới',
  'sys.edit': 'Chỉnh sửa',
  'sys.preview': 'Xem trước',
  'sys.delete': 'Xóa',
  'sys.enable': 'Bật',
  'sys.disable': 'Tắt',
  'sys.search': 'Tìm kiếm',
  'sys.reset': 'Đặt lại',
  'sys.total': 'Tổng {total} mục',
  'sys.addSuccess': 'Thêm thành công',
  'sys.editSuccess': 'Chỉnh sửa thành công',
  'sys.deleteSuccess': 'Xóa thành công',
  'sys.enableSuccess': 'Bật thành công',
  'sys.disableSuccess': 'Tắt thành công',
  'sys.addFailed': 'Thêm thất bại',
  'sys.editFailed': 'Chỉnh sửa thất bại',
  'sys.deleteFailed': 'Xóa thất bại',
  'sys.enableFailed': 'Bật thất bại',
  'sys.disableFailed': 'Tắt thất bại',
  'sys.confirmDelete': 'Bạn có chắc chắn muốn xóa?',
  'sys.confirmEnable': 'Bạn có chắc chắn muốn bật?',
  'sys.confirmDisable': 'Bạn có chắc chắn muốn tắt?',
  'sys.required': 'Bắt buộc',
  'sys.pleaseSelect': 'Vui lòng chọn',
  'sys.pleaseEnter': 'Vui lòng nhập',
  'sys.all': 'Tất cả',
  'sys.enabled': 'Đã bật',
  'sys.disabled': 'Đã tắt',
  'sys.operator': 'Người thực hiện',
  'sys.operateTime': 'Thời gian thực hiện',

  // Email Template Modal
  'email.template.modal.title.edit': 'Chỉnh sửa mẫu email',
  'email.template.modal.title.add': 'Thêm mẫu email',
  'email.template.modal.language': 'Ngôn ngữ',
  'email.template.modal.language.placeholder': 'Vui lòng chọn ngôn ngữ',
  'email.template.modal.businessType': 'Loại nghiệp vụ',
  'email.template.modal.businessType.placeholder': 'Vui lòng chọn loại nghiệp vụ',
  'email.template.modal.subject': 'Tiêu đề email',
  'email.template.modal.subject.placeholder': 'Vui lòng nhập tiêu đề email',
  'email.template.modal.content': 'Mẫu email',
  'email.template.modal.content.placeholder': 'Vui lòng nhập nội dung email',
  'email.template.modal.sender': 'Hiển thị người gửi',
  'email.template.modal.sender.placeholder': 'Vui lòng nhập người gửi',
  'email.template.modal.format': 'Định dạng email',
  'email.template.modal.format.placeholder': 'Vui lòng chọn định dạng email',
  'email.template.modal.receipt': 'Yêu cầu xác nhận',
  'email.template.modal.receipt.placeholder': 'Vui lòng chọn yêu cầu xác nhận',
  'email.template.modal.receipt.yes': 'Có',
  'email.template.modal.receipt.no': 'Không',

  // Email Config Modal
  'email.config.modal.title.edit': 'Chỉnh sửa email',
  'email.config.modal.title.add': 'Thêm email',
  'email.config.modal.type': 'Loại email',
  'email.config.modal.type.placeholder': 'Vui lòng chọn loại email',
  'email.config.type.80002001': 'Email Microsoft',
  'email.config.type.80002002': 'Email Google',
  'email.config.modal.account': 'Địa chỉ email',
  'email.config.modal.account.placeholder': 'Vui lòng nhập địa chỉ email',
  'email.config.modal.password': 'Mật khẩu email',
  'email.config.modal.password.placeholder': 'Vui lòng nhập mật khẩu email',
  'email.config.modal.smtp': 'SMTP',
  'email.config.modal.smtp.placeholder': 'Vui lòng nhập địa chỉ SMTP',
  'email.config.modal.port': 'Cổng',
  'email.config.modal.port.placeholder': 'Vui lòng nhập số cổng',

  // Email Template List
  'email.template.list.title': 'Danh sách mẫu email',
  'email.template.list.search.businessType': 'Loại nghiệp vụ',
  'email.template.list.search.language': 'Ngôn ngữ',
  'email.template.list.search.button': 'Tìm kiếm',
  'email.template.list.search.reset': 'Đặt lại',
  'email.template.list.add': 'Thêm mới',
  'email.template.list.edit': 'Chỉnh sửa',
  'email.template.list.enable': 'Bật',
  'email.template.list.disable': 'Tắt',
  'email.template.list.delete': 'Xóa',
  'email.template.list.delete.confirm': 'Bạn có chắc chắn muốn xóa?',
  'email.template.list.status.enabled': 'Đã bật',
  'email.template.list.status.disabled': 'Đã tắt',
  'email.template.list.operator': 'Người thực hiện',
  'email.template.list.operateTime': 'Thời gian thực hiện',

  // Email Config List
  'email.config.list.title': 'Danh sách cấu hình email',
  'email.config.list.search.status': 'Trạng thái',
  'email.config.list.search.status.all': 'Tất cả',
  'email.config.list.search.status.enabled': 'Đã bật',
  'email.config.list.search.status.disabled': 'Đã tắt',
  'email.config.list.search.account': 'Địa chỉ email',
  'email.config.list.search.account.placeholder': 'Vui lòng nhập địa chỉ email',
  'email.config.list.search.button': 'Tìm kiếm',
  'email.config.list.search.reset': 'Đặt lại',
  'email.config.list.add': 'Thêm email',
  'email.config.list.edit': 'Chỉnh sửa',
  'email.config.list.enable': 'Bật',
  'email.config.list.disable': 'Tắt',
  'email.config.list.delete': 'Xóa',
  'email.config.list.delete.confirm': 'Bạn có chắc chắn muốn xóa?',
  'email.config.list.status.enabled': 'Đã bật',
  'email.config.list.status.disabled': 'Đã tắt',
  'email.config.list.operator': 'Người thực hiện',
  'email.config.list.operateTime': 'Thời gian thực hiện',
}; 